import { InjectionToken } from '@angular/core';
import { Subject } from 'rxjs';
import { BaseCancellationComponent } from '../base-cancellation/base-cancellation.component';

export interface CancellationComponentInterface {
    modalResult: Subject<{
        notificationUpdateKey: string;
    }>;
}

// TODO: replace me with a service that is used in the cancellationcomponent
// currently just a workaround because cancellationcomponent has dependency to pace-forms and therefore can't move to pace-core
export const CancellationComponentInstanceToken = new InjectionToken<BaseCancellationComponent>(
    'CancellationComponent',
);
